import { Routes, BrowserRouter, Route, Navigate, Link } from "react-router-dom";
import { PrismicProvider, PrismicToolbar } from "@prismicio/react";
import React from 'react';
import { client, repositoryName } from "./prismic";
import { Home } from "./pages/Home";
import { NotFound } from "./pages/NotFound";
import { Post } from "./pages/Post";
import { Preview } from "./pages/Preview";
import ReactFlagsSelect from "react-flags-select";

/**
 * Main app component
 */
export const App = () => {
  global.mainColor = '#EE3456'
  var userLang = navigator.language || navigator.userLanguage; 
  const [selected, setSelected] = React.useState(userLang?.split('-')?.[1] || 'US');
  return (
    <PrismicProvider
      client={client}
      internalLinkComponent={({ href, ...props }) => (
        <Link to={href} {...props} />
      )}
    >
  
{1==2 && <div style={{right: 20, position:'absolute', alignSelf:'flex-end'}}>
<ReactFlagsSelect countries={["US", "DE", "PT", "ES", "FR"]}
  selected={selected}
  searchable={false}
  onSelect={(code) => {
    global.code = code;
    setSelected(code);
    localStorage.setItem('lang', code)
     }}
/>
</div>}

      <BrowserRouter basename={window.location.href.includes('/learn') ?  "/learn" : "/"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/preview" element={<Preview />} />
          <Route path="/blog" element={<Navigate to="/" />} />
          <Route path="/blog/:uid" element={<Post />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <PrismicToolbar repositoryName={repositoryName} />
    </PrismicProvider>
  );
};
